import React, { useEffect, useState } from "react";
import { ArrowRight, ChartBar, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GrowthEngineForYourCompany() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX / window.innerWidth * 20,
        y: e.clientY / window.innerHeight * 20
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="17693" id="sua-contabilidade-na-irlanda-sem-complicações" ref={sectionRef} className="relative min-h-[90vh] w-full overflow-hidden bg-background dark flex items-center justify-center py-20 lg:py-0">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.1]" style={{
      backgroundImage: `
            linear-gradient(to right, var(--foreground) 1px, transparent 1px),
            linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)
          `,
      backgroundSize: "60px 60px",
      transform: `translate(${mousePosition.x * -1}px, ${mousePosition.y * -1}px)`,
      transition: "transform 0.2s ease-out"
    }} />
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center rounded-full border border-secondary/30 bg-secondary/10 px-3 py-1 text-sm font-medium text-secondary backdrop-blur-sm">
                <ChartBar className="mr-2 h-4 w-4" />
                <span className="font-mono tracking-wider uppercase !text-[hsl(43,96%,56%)]">Excelência Contábil</span>
              </div>
              
              <h1 className="text-5xl font-bold tracking-tighter sm:text-6xl xl:text-7xl/none text-white">
                Contabilidade na Irlanda{" "}
                <span className="bg-gradient-to-r from-white to-emerald-100 bg-clip-text text-transparent">
                  Sem Complicações
                </span>
              </h1>
              
              <p className="max-w-[600px] text-muted-foreground md:text-xl leading-relaxed font-sans">
                A KRB Accounting Services é sua parceira estratégica para conformidade fiscal e otimização financeira em solo irlandês. Transformamos burocracia em tranquilidade para o seu negócio prosperar.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Link to="#">
                <Button size="lg" className="group relative overflow-hidden rounded-full bg-secondary text-secondary-foreground shadow-[0_0_25px_-5px_hsl(45,90%,50%)] hover:shadow-[0_0_35px_-5px_hsl(45,90%,50%)] transition-all duration-300 border-none">
                  <span className="relative z-10 flex items-center font-bold">
                    Fale Conosco
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                  <div className="absolute inset-0 -z-0 bg-gradient-to-r from-secondary to-yellow-400 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                </Button>
              </Link>
              
              <Link to="#">
                <Button variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-10 px-6 has-[>svg]:px-4 rounded-full border-secondary/40 text-secondary transition-colors !bg-[hsl(210,17%,98%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-secondary/10 hover:border-secondary">Ver Serviços</Button>
              </Link>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground font-medium">
              <div className="flex items-center gap-1">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span>Equipe Certificada</span>
              </div>
              <div className="flex items-center gap-1">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span>Suporte em Português</span>
              </div>
              <div className="flex items-center gap-1">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span>Conformidade CRO/Revenue</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-[500px] lg:max-w-none transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute -inset-4 rounded-[2.5rem] border border-secondary/20 bg-gradient-to-br from-secondary/10 to-transparent backdrop-blur-[2px] -rotate-3 scale-105 z-0" />
            <div className="absolute -inset-4 rounded-[2.5rem] border border-emerald-500/10 rotate-2 scale-105 z-0" />

            {}
            <div className="relative z-10 overflow-hidden rounded-3xl shadow-2xl shadow-black/40 border border-border/20 bg-card/40 backdrop-blur-md" style={{
            animation: "float 6s ease-in-out infinite"
          }}>
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent z-20" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/modern_entrepreneur_floating.png" alt="Empresário brasileiro analisando dados financeiros em Dublin" className="h-full w-full object-cover object-center scale-105 hover:scale-110 transition-transform duration-1000" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 z-30 p-5 rounded-2xl bg-card/95 backdrop-blur-xl border border-secondary/20 shadow-2xl">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-semibold text-muted-foreground font-mono uppercase tracking-tight">Status de Conformidade</span>
                  <span className="text-xs font-bold text-secondary-foreground bg-secondary px-3 py-1 rounded-full">100% OK</span>
                </div>
                <div className="h-2.5 w-full bg-secondary/20 rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-emerald-500 to-secondary w-[100%]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(1deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
      `}</style>
    </section>;
}